import { Person } from "~types/types";

export const getAuthorThumbnail = (author: Person): string | undefined => {
    if (author.photoDisplayed) {
        return author.thumbnail?.url;
    }

    return undefined;
};
